import { sortCategories } from '@yesplz/visualfilter/src/extended-configuration';

export default sortCategories;
